import { Reveal } from "./Reveal";

const STEPS = [
  ["01", "Employer Requirement", "We capture the exact manpower need, terms and timeline."],
  ["02", "Candidate Sourcing", "Targeted sourcing from our verified international network."],
  ["03", "Screening & Verification", "Identity, qualification and experience checks."],
  ["04", "Interview / Selection", "Coordinated interviews and structured shortlisting."],
  ["05", "Documentation", "Contract and document preparation and review."],
  ["06", "Work Permit Process", "Work-permit and immigration coordination where applicable."],
  ["07", "Visa / Travel Support", "Visa guidance and pre-departure travel support."],
  ["08", "Deployment", "Arrival, onboarding and post-deployment follow-up."],
];

export const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="py-24 md:py-32 px-6 md:px-12 bg-[#f5f5f4] border-y border-[#e4e4e7]"
  >
    <div className="max-w-[1600px] mx-auto">
      <Reveal>
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
          Our recruitment process
        </p>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl mb-16 md:mb-20">
          Eight steps,
          <br />
          fully verified.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-px bg-[#e4e4e7] border border-[#e4e4e7]">
        {STEPS.map(([n, title, body], i) => (
          <Reveal key={n} delay={(i % 4) * 0.06}>
            <div
              data-testid={`process-step-${n}`}
              className="group h-full bg-white hover:bg-[#0a0a0a] p-8 transition-colors duration-500"
            >
              <span className="font-head text-5xl md:text-6xl text-[#e4e4e7] group-hover:text-[#ff3b30] transition-colors duration-500">
                {n}
              </span>
              <h3 className="font-head uppercase tracking-tight text-xl md:text-2xl mt-6 mb-3 group-hover:text-white transition-colors duration-500">
                {title}
              </h3>
              <p className="font-body text-sm text-[#52525b] group-hover:text-[#a1a1aa] leading-relaxed transition-colors duration-500">
                {body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
